import type { DirectiveBinding } from 'vue'
import { isFloat } from '@/utils/regs'
export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    if (binding.value === undefined) return
    const inputEl = el.getElementsByTagName('input')[0]
    if (!inputEl) return
    // const fixedValue = binding.value || 2
    const fixedValue = binding.value === undefined ? 2 : binding.value
    inputEl.oninput = handleInput
    let locking = false
    inputEl.addEventListener('compositionstart', () => {
      // console.log('compositionstart')
      locking = true// 解决中文输入双向绑定失效
    })
    inputEl.addEventListener('compositionend', () => {
      locking = false// 解决中文输入双向绑定失效
      inputEl.dispatchEvent(new CustomEvent('input', { detail: 'end' }))
    })

    function handleInput(event: CustomEvent) {
      if (locking || (!event.isTrusted && event.detail === 'update')) return // event.isTrusted 是否是用户触发的
      const inputValue = inputEl.value
      // 符合浮点数规范，直接返回
      if (inputValue && isFloat(inputValue, fixedValue)) return
      // 替换非浮点数的字符
      const replaceReg = !fixedValue ? /(?<!^)-|[^\d-]/g : /(?<!^)-|[^\d-\.]/g  // eslint-disable-line
      // const replaceReg = !fixedValue ? /[^0-9]/g : /[^0-9\.]/g
      // let temp = inputValue.replace(/[^0-9\\.]/g, '') // 替换成0
      let temp = inputValue.replace(replaceReg, '') // 替换成0
      // 只保留一个小数点
      let dotCount = 0
      temp = temp.replace(/\./g, (match) => {
        dotCount++
        return dotCount === 1 ? match : ''
      })
      const index = temp.indexOf('.')
      let newValue = inputValue
      if (index > -1)
        newValue = `${temp.slice(0, index) || 0}.${temp.slice(index + 1, index + 1 + fixedValue)}`
      else
        newValue = temp

      if (newValue !== inputValue) { // 值有变化时触发更新
        nextTick(() => { // firefox更新时机需要nextTick
          inputEl.value = newValue
          inputEl.dispatchEvent(new CustomEvent('input', { detail: 'update' }))
        })
      }
    }
  },
  beforeUnmount(el: HTMLElement) {
    const inputEl = el.getElementsByTagName('input')[0]
    if (!inputEl) return
    inputEl.oninput = null
  },
}
